import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import { FormControl, MenuItem } from "@mui/material";

import { SelectStyled } from "./styles";

const languageLabels = {
  en: "EN",
  es: "ESP",
};

export default function LanguageSelector() {
  const {
    languages,
    changeLanguage,
    i18n: { language },
  } = useI18next();

  const handleLanguageChange = (event) => changeLanguage(event.target.value);

  return (
    <FormControl size="small" sx={{ minWidth: 90 }}>
      <SelectStyled
        id="language-select-mobile"
        value={language}
        onChange={handleLanguageChange}
      >
        {languages.map((lang) => (
          <MenuItem key={lang} value={lang}>
            {languageLabels[lang]}
          </MenuItem>
        ))}
      </SelectStyled>
    </FormControl>
  );
}
